<template>

  <div v-if="tags">
    <chips :tags="sortBy(relationships, (c) => c.toLowerCase())" title="Relationships"></chips>
    <chips :tags="sortBy(characters, (c) => c.toLowerCase())" title="Characters"></chips>
  </div>
  <div v-else class="requested-characters">
    <strong v-if="!hideTitle" class="chip-title">Characters & Relationships &nbsp;</strong>
    <template v-if="relationships">
      <ul class="characters mt-2">
        <li v-for="c in sortBy(relationships, (c) => c.toLowerCase())" :key="c">
          {{ c }}
        </li>
      </ul>
    </template>
    <template v-if="characters">
      <div v-if="
        relationships &&
        relationships.length &&
        characters &&
        characters.length
      " class="divider my-4 text-center" data-content="+" />
      <ul class="characters mt-2">
        <li v-for="c in sortBy(characters, (c) => c.toLowerCase())" :key="c">
          {{ c }}
        </li>
      </ul>
    </template>
    <div v-if="!relationships && !characters">None</div>
  </div>
</template>

<script>
import { sortBy } from "lodash-es";
import { mapGetters } from "vuex";
import chips from "./chips.vue";

export default {
  name: "character-list",
  components: {
    chips
  },
  props: {
    tags: {
      type: Boolean,
      default: false
    },
    hideTitle: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    relationships: {
      type: Array,
      default() {
        return [];
      }
    },
    characters: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  computed: {
    ...mapGetters(["options"]),
    sortedTags() {
      if (!this.tags) return [];
      return sortBy(this.tags, t => t.toLowerCase());
    }
  },
  methods: { sortBy }
};
</script>
